import { LinkOperation } from "namirasoft-site-react";
import { Component } from "react";
import { InferencerTreeNode } from "./InferencerTree";
import Styles from "./InferencerVisualizer.module.css";

export interface InferencerVisualizerProps
{
    tree: InferencerTreeNode | null;
    loading?: boolean;
    error?: string | null;
    depth?: number;
    showTitle?: boolean;
}

interface TypeStyle
{
    label: string;
    icon: string;
    className: string;
}

const TYPE_STYLES: Record<string, TypeStyle> =
{
    MODEL: { label: "Model", icon: "M", className: Styles.type_model },
    LOAD_BALANCER: { label: "Load Balancer", icon: "LB", className: Styles.type_load_balancer },
    FAILOVER: { label: "Failover", icon: "FO", className: Styles.type_failover },
    RACE: { label: "Race", icon: "RC", className: Styles.type_race },
    ROUTER: { label: "Router", icon: "RT", className: Styles.type_router },
    GATEWAY: { label: "Gateway", icon: "GW", className: Styles.type_gateway },
};

export default class InferencerVisualizer extends Component<InferencerVisualizerProps>
{
    private renderCard(node: InferencerTreeNode | null): React.ReactNode
    {
        let typeKey = node ? String(node.type).toUpperCase() : "";
        let style = TYPE_STYLES[typeKey] ?? { label: typeKey || "Inferencer", icon: "?", className: "" };
        let text: string;
        if (this.props.loading) text = "Loading…";
        else if (this.props.error) text = this.props.error;
        else text = node?.name ?? "Not found";

        let content = (
            <>
                <span className={Styles.node_icon}>{style.icon}</span>
                <div className={Styles.node_body}>
                    <span className={Styles.node_type}>{style.label}</span>
                    <span className={Styles.node_name}>{text}</span>
                    {node?.subtitle && <span className={Styles.node_subtitle}>{node.subtitle}</span>}
                </div>
                {node?.meta && node.meta.length > 0 && (
                    <div className={Styles.node_meta}>
                        {node.meta.map((m, i) => <span key={i} className={Styles.node_pill}>{m}</span>)}
                    </div>
                )}
            </>
        );
        if (node?.href)
            return (
                <a
                    href={node.href}
                    className={`${Styles.node_card} ${style.className}`}
                    onClick={(e) => { e.preventDefault(); LinkOperation.open(node.href); }}
                >
                    {content}
                </a>
            );
        return (
            <div className={`${Styles.node_card} ${style.className}`}>
                {content}
            </div>
        );
    }

    override render()
    {
        let depth = this.props.depth ?? 0;
        let node = this.props.tree;
        let card = (
            <div className={Styles.node}>
                {this.renderCard(node)}
                {node && node.children.length > 0 && (
                    <div className={Styles.children}>
                        {node.children.map((c, i) => (
                            <div key={`${c.node.id}-${i}`} className={Styles.child_wrapper}>
                                {c.label && <span className={Styles.child_label}>{c.label}</span>}
                                <InferencerVisualizer
                                    tree={c.node}
                                    depth={depth + 1}
                                    showTitle={false}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
        if (depth > 0)
            return card;
        let showTitle = this.props.showTitle ?? true;
        return (
            <div className={Styles.container}>
                <div className={Styles.tree_root}>
                    {showTitle && <div className={Styles.tree_title}>Inferencer Structure</div>}
                    {card}
                </div>
            </div>
        );
    }
}